import { toastError, toastSuccess } from '@onestep/coreui/Toast';
import { concat, find, map } from 'lodash';

import useClinicalRecordService from '../../../../services/clinicalRecordService';
import { AFFECTED_SIDE_OPTIONS } from '../../ClinicalRecord/clinicalRecordOptions';
import useAchievementEvent from './useAchievementEvent';
import useInjuryEvent from './useInjuryEvent';
import useOtherEvent from './useOtherEvent';

export default function useClinicalRecordEvent(patientUuid: string) {
  const injuryEventList = useInjuryEvent(patientUuid);
  const achievementEventList = useAchievementEvent(patientUuid);
  const otherEventList = useOtherEvent(patientUuid);
  const { deleteClinicalHistory } = useClinicalRecordService(patientUuid ?? '');

  const deleteEvent = async (id: string) => {
    try {
      await deleteClinicalHistory(id);
      toastSuccess({ content: `The event Deleted Successfully!` });
    } catch (error) {
      toastError({ content: 'Failed to delete event!' });
    }
  };

  return map(concat(injuryEventList, achievementEventList, otherEventList), (event) => ({
    ...event,
    isToShowUpdateIcons: true,
    id: event.id,
    tabName: event.tabName,
    description: `${
      find(AFFECTED_SIDE_OPTIONS, { value: event.affectedSide })?.label ?? ''
    }${event.description ? `, ${event.description}` : ''}`,
    onDelete: deleteEvent,
  }));
}
